import { useCallback } from 'react';

import { CartServiceAeroexpress, CartServiceGds, CartServiceInsurance, OnDeleteItemType } from '../../../Cart/types';
import { CardExtraService } from '../../types';

import { useCardExtraCtx } from '../CardExtra.context';

export function useCardExtraSummaryDelete() {
	const { type, flight, onRemoveServices } = useCardExtraCtx();

	const onDelete: OnDeleteItemType = useCallback(
		(_, service) => {
			const removeServices: CardExtraService[] = [];

			if (type === 'insurance') {
				const insuranceService = service as CartServiceInsurance;

				removeServices.push({ code: insuranceService.code });
			} else if (type === 'transfer') {
				const transferService = service as CartServiceAeroexpress;

				removeServices.push({ id: transferService.tripId });
			} else {
				const gdsService = service as CartServiceGds;

				removeServices.push({
					count: 0,
					serviceId: gdsService.serviceId,
					passengerId: gdsService.passengerId,
					segmentIds: gdsService.allSegments
						? flight.segments.map(segment => segment.segment.id)
						: gdsService.segmentId
						? [gdsService.segmentId]
						: null
				});
			}

			if (removeServices.length) {
				onRemoveServices(removeServices);
			}
		},
		[type, flight, onRemoveServices]
	);

	return onDelete;
}
